import { render, staticRenderFns } from "./CompatibilityBlock.vue?vue&type=template&id=8a02d300&scoped=true&"
import script from "./CompatibilityBlock.vue?vue&type=script&lang=js&"
export * from "./CompatibilityBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a02d300",
  null
  
)

export default component.exports